<template>
  <div class="modules-content" style="margin-top:0px;">
    <div class="module-item" data-id="1" data-module-lessons="23">
      <div class="title-content custom-grid">
        <h3 class="module-title" style="font-size: 14px;">
          Informações
          <i class="icon icon-alert-circle-i"></i>
          <div class="module-description-tooltip">Informações</div>
        </h3>

        <span class="module-progress loading-placeholder" style="display: block;">
          <div v-if="userType == 0" class="control-group">
            <select v-model="selectedStudent" id="student" class="form-control">
              <option value="0" disabled selected>Escolha um aluno</option>
              <option v-for="u in users" v-bind:key="u.id" v-bind:value="u.id">{{u.name}}</option>
            </select>
          </div>
        </span>

        <span class="module-progress loading-placeholder" style="display: block;">
          <div class="control-group">
            <select v-model="selectedCourse" id="course" class="form-control">
              <option value="0" disabled selected>Escolha um curso</option>
              <option v-for="c in courses" v-bind:key="c.id" v-bind:value="c.id">{{c.name}}</option>
            </select>
          </div>
        </span>

        <span class="module-progress loading-placeholder" style="display: block;">
          <lms-button
            style="margin-right:5px;"
            @click="getStudentData"
            :loading="loadingData"
          >Filtrar</lms-button>
          <lms-button
            style="margin-right:5px;"
            @click="exportData"
            :loading="loadingData"
          >Exportar Dados</lms-button>
          <lms-button
            style="margin-right:5px;"
            @click="selectedCourse = 0; selectedStudent = 0;"
            :loading="loadingData"
          >Limpar</lms-button>
        </span>
      </div>

      <li class="lesson-subtitle">
        <span class="lesson-title">Aluno</span>
        <span class="lesson-title">Curso</span>
        <span class="lesson-progress">Progresso</span>
        <span class="lesson-title">Matrícula - Início</span>
        <span class="lesson-title">Matrícula - Fim</span>
        <span class="lesson-status">Certificado</span>

        <!-- <span class="lesson-option"></span> -->
      </li>

      <ul class="lessons-list">
        <li
          v-for="(data,index) in studentData"
          :key="index"
          class="lesson"
          data-id="64"
          data-videos="1"
        >
          <span class="lesson-title">{{data.userName}}</span>
          <span class="lesson-title">{{data.courseName}}</span>

          <span class="lesson-progress" style="display: flex;">
            {{studentProgress(data.watchedVideos,data.totalVideos)}}
            <span class="progress-bar">
              <small v-bind:style="{ width: studentProgress(data.watchedVideos,data.totalVideos) }"></small>
            </span>
            <div class="progress-description-tooltip">
              <p>Vídeos assistidos: {{data.watchedVideos}}</p>
              <p>Total de vídeos: {{data.totalVideos}}</p>
            </div>
          </span>

          <span class="lesson-title">{{data.registration}}</span>
          <span class="lesson-title">{{data.endRegistration}}</span>

          <span v-if="data.hasCertificate" class="lesson-status" style="display: flex;">
            <span class="lesson-status finished loading-placeholder">
              <span class="icon icon-c-check"></span> Emitido
            </span>
          </span>
          <span v-else class="lesson-status" style="display: flex;">
            <span class="lesson-status in-progress loading-placeholder">
              <i class="material-icons">error_outline</i>Não emitido
            </span>
          </span>

          <!-- <span class="lesson-option">
                <a href="/aluno/turma/19/aula/64/" style="font-size: 14px;">Detalhes</a>
          </span>-->
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import axios from "axios";

export default {
  props: {
    users: {
      type: Array,
      required: true
    },
    courses: {
      type: Array,
      required: true
    },
    studentData: {
      type: Array,
      required: true
    },
    loadingData: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      userType: this.$store.getters.user.type,
      selectedStudent: 0,
      selectedCourse: 0
    };
  },
  components: {},
  methods: {
    studentProgress(watched, total) {
      return parseInt((watched / total) * 100) + "%";
    },
    getStudentData() {
      this.$emit("getStudentData", this.selectedStudent, this.selectedCourse);
    },
    // exportData() {
    //   const path = this.$global.endpoint + "/analytics/exportdata";
    //   axios
    //     .post(path, {
    //       userId: this.selectedStudent,
    //       courseId: this.selectedCourse
    //     },
    //       method: 'POST',
    //       responseType: 'blob', // important
    //     )
    //     .then(res => {
    //       console.log("voltou");
    //       console.log(res);
    //       this.loadingData = false;
    //     })
    //     .catch(error => {
    //       console.error(error);
    //       this.loadingData = false;
    //     });
    // },
    exportData() {
      console.log(course.id);
      const path = this.$global.endpoint + "/analytics/exportdata";

      axios({
        url: path,
        data: {
          userId: this.selectedStudent,
          courseId: this.selectedCourse
        },
        method: "POST",
        responseType: "blob" // important
      })
        .then(res => {
          var blob = new Blob([res.data], { type: "text/csv" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "dados.csv";
          link.click();
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  created() {}
};
</script>
